<app-kyc-kyb-header [scope]="scope" [status]="status()" [headingLevel]="headingLevel()" />
<div class="margin-top-2">
    @if (status()) {
        <span>{{ 'payroll.kyc-kyb.profile.' + scope + '.status.' + status()?.toUpperCase() | translate }}</span
        >&nbsp;<span
            innerHTML="{{
                'payroll.kyc-kyb.forMoreInfo.message'
                    | translate: { helpCenterUrl: 'payroll.kyc-kyb.forMoreInfo.helpCenterUrl' | translate }
            }}"
        ></span>
    }
</div>
<!-- Only show the button for incomplete inquiries and only when the user is viewing their own profile -->
@if (status() === 'not_complete' && !employee) {
    <ui-button [url]="linkToPreRedirect" class="margin-top-2" type="primary">
        {{ 'payroll.kyc-kyb.profile.' + scope + '.launch' | translate }}
    </ui-button>
}
